import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateStatusReportComponent } from './create-status-report.component';

const routes: Routes = [
  {
    path: '',
    component: CreateStatusReportComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateStatusReportRoutingModule { }
